import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from '@hello-pangea/dnd';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import DownItems from '../../../assets/Images/down-arrow.svg';
import DragItems from '../../../assets/Images/drag.svg';
import UpItems from '../../../assets/Images/up-arrow.svg';
import { MoveProcessEnum } from '../../../constants/enums';
import DimensionTypeEnum from '../../../constants/enums/dimension-types';


import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../translations/format-message';

interface IProps extends IAddEditFormProps<any> {
  processOrder: any[];
  isDimension?: boolean;
}

const ProcessReorderForm = (props: IProps) => {
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    if (!props.processOrder) return;

    // CASE 1: Process API (existing behavior)
    const isProcessList = !props.isDimension;

    // CASE 2: Dimension API (new behavior)
    const isDimensionList = props.isDimension;

    let mappedItems: any[] = [];

    if (isProcessList) {
      // 🟢 PROCESS API MAPPING
      mappedItems = props.processOrder.map((p) => ({
        id: String(p.Id),
        name: p.ProcessName,
        shortName: p.ShortName,
        type: p.Type,
        IsHidden: p.IsHidden ?? p.Hide ?? 'false',
      }));
    }

    if (isDimensionList) {
      // 🟢 DIMENSION API MAPPING (New ProductStore Source)
      mappedItems = props.processOrder.map((d) => ({
        id: String(d.Id),
        name: d.Messages, // column name
        shortName: "",
        type: formatMessage(DimensionTypeEnum[d.MessagesType]), // convert enum number to string key
        IsHidden: false,

        // Process Name not available in this API response, user hid the column
        processNames: ""
      }));
    }

    setItems(mappedItems);
  }, [props.processOrder, props.isDimension]);

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const reordered = Array.from(items);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);

    setItems(reordered);
  };

  const moveItem = (index: number, direction: MoveProcessEnum) => {
    const newIndex = direction === MoveProcessEnum.Up ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= items.length) return;

    const updated = [...items];
    const temp = updated[index];
    updated[index] = updated[newIndex];
    updated[newIndex] = temp;

    setItems(updated);
  };

  const handleHideToggle = (id: string) => {
    setItems((prev) =>
      prev.map((i) => (i.id === id ? { ...i, IsHidden: !i.IsHidden } : i))
    );
  };

  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validateOnBlur={false}
        onSubmit={async (_: any) => {
          props.submitHandler(items);
        }}
      >
        {({ setFieldValue }) => {
          return (
            <Form className="user-form">
              {props.isLoading ? (
                <FormLoader loading={props.isLoading} contained />
              ) : null}
              <Modal.Body>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="grid">
                    {(provided) => (
                      <div className="order-column">
                        <table
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          className="min-w-full table-auto border border-gray-300 w-100"
                        >
                          <thead>
                            <tr className="bg-gray-200">
                              {/* Do not remove They are in use */}


                              {items.length > 0 && items[0].processNames !== undefined ? (
                                <>
                                 <th className="border px-4 py-2 text-center w-16">
                                <span className="ms-1">
                                  {formatMessage('serial_number')}
                                </span>
                              </th>
                                  <th className="border px-4 py-2">
                                    {formatMessage('messages')}
                                  </th>
                                  {/* <th className="border px-4 py-2">
                                    {formatMessage('messages_type')}
                                  </th> */}
                                  {/* <th className="border px-4 py-2">
                                    {formatMessage('ProcessName')}
                                  </th> */}
                                </>
                              ) : (
                                <>
                                <th className="border px-4 py-2 text-center w-16">
                                <span className="ms-1">
                                  {formatMessage('hide_column')}
                                </span>
                              </th>
                                  <th className="border px-4 py-2">
                                    {formatMessage('name')}
                                  </th>
                                  <th className="border px-4 py-2">
                                    {formatMessage('short_name')}
                                  </th>
                                  <th className="border px-4 py-2">
                                    {' '}
                                    {formatMessage('process_type')}
                                  </th>
                                </>
                              )}
                              <th className="border px-4 py-2">
                                {' '}
                                {formatMessage('actions')}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {items.map((item, index) => (
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided) => (
                                  <tr
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className="border-b"
                                  >
                                    {/* Do not remove They are in use */}
                                    <td
                                      className="border px-4 py-2 text-center"
                                      onClick={(e) => e.stopPropagation()} // keep checkbox from starting a drag
                                    >
                                      {props.isDimension ? (
                                        <span>{index + 1}</span>
                                      ) : (
                                        <input
                                          // name="IsHidden"
                                          className='form-check-input'
                                          type="checkbox"
                                          checked={item.IsHidden}
                                          onChange={() =>
                                            handleHideToggle(item.id)
                                          }
                                          aria-label={`Hide ${item.name}`}
                                        />
                                      )}
                                    </td>
                                    <td className="border px-4 py-2">
                                      <img
                                        src={DragItems}
                                        alt=""
                                        className="drag me-2"
                                      />{' '}
                                      {item.name}
                                    </td>
                                    {props.isDimension ? (
                                      <>
                                        {/* <td className="border px-4 py-2">
                                          {item.type}
                                        </td> */}
                                        {/* <td className="border px-4 py-2">
                                          {item.processNames}
                                        </td> */}
                                      </>
                                    ) : (
                                      <>
                                        <td className="border px-4 py-2">
                                          {item.shortName}
                                        </td>
                                        <td className="border px-4 py-2">
                                          {formatMessage(item.type)}
                                        </td>
                                      </>
                                    )}
                                    <td className="border px-4 py-2 space-x-2 bg-red-100 up-down-items last-column">
                                      <div className="d-flex">
                                        <button
                                          type="button"
                                          onClick={() =>
                                            moveItem(index, MoveProcessEnum.Up)
                                          }
                                          disabled={index === 0}
                                          className={`px-2 py-1 bg-green-600 rounded btn-light-primary btn-sm ${index === 0 && 'disabled-li'}`}
                                        >
                                          <img
                                            src={UpItems}
                                            alt=""
                                            className="drag"
                                          />
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            moveItem(
                                              index,
                                              MoveProcessEnum.Down
                                            )
                                          }
                                          disabled={index === items.length - 1}
                                          className={`px-2 py-1 bg-green-600 rounded btn-light-danger btn-sm ${index === items.length - 1 && 'disabled-li'}`}
                                        >
                                          <img
                                            src={DownItems}
                                            alt=""
                                            className="drag"
                                          />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Modal.Body>
              <ModalFooter
                id={props.id}
                onModalClosed={props.onModalClosed}
                isLoading={props.isLoading}
                saveNextBtn={'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ProcessReorderForm;
